import CityPageTemplate from "@/components/site/CityPageTemplate";

export default function FinanzberatungHalle() {
  return (
    <CityPageTemplate
      city="Halle"
      slug="halle"
      intro="Halle an der Saale wächst – nutze die Chancen und staatlichen Förderungen für Deinen Vermögensaufbau."
      description="Unabhängige & digitale Finanzberatung für Halle: Altersvorsorge, ETF, Steueroptimierung und staatliche Förderungen. Kostenlose Erstberatung – 100% digital."
    />
  );
}
